<template>
  <div>
    <router-view></router-view>
  </div>
</template>
<style>
@import "./content.css";
</style>
<script type="babel">
import UTILS from '@/utils/utils';
import YC_REQUEST_HANDLER from "@/api/request.js";
import { mapState, mapActions, mapGetters } from 'vuex';
import DBUtils from '@/utils/dbUtils';
export default {
    name: "v-content",
    computed: {
	    ...mapState({
			user: state => state.user,
            org: state => state.org,
            token: state => state.token
	    }),
	    ...mapGetters({
	        login: 'checkLogin',
	    })
    },
    mounted: async function() {
        this.$bus.on("common-error-handler", this.commonErrorHandler);
        this.$bus.on("html-notification", this.showNotificationWithHTML);
        this.$bus.on("commmon-notification", this.showNotification);
        // this.$bus.on("toAccountLogin", this.accountLogin);
        this.$bus.on("loginByToken", this.toLoginByToken);
        this.$bus.on('toTrailPage', this.gotoTrailPage)
        this.$bus.on('create-order', this.createOrder)
        this.srollToTop()
    },
    watch:{
        $route: function() {
            let errMsg = window.sessionStorage.errMsg
            if (errMsg) {
                this.$message(errMsg)
                window.sessionStorage.removeItem('errMsg')
            }
        },
    },
    methods: {
        login: function() {
            console.log('reach notify')
        },
        srollToTop: function() {
            window.scrollTo(0,0)
        },
        toLoginByToken: function() {
            if (window.localStorage.getItem("userName")) {
                return;
            }
            let search = window.location.search;
            if (search.indexOf("token") > -1) {
                let token = search.substring(search.length - 32),
                url = "/api/uc/eft/login/token",
                params = {
                    token: token
                };
                var successCallBack = function(response) {
                    _this.loginSuccessHandler(response);
                    _this.getUserInfo();
                },
                failCallBack = function(code, msg, data) {
                    _this.commonErrorHandler("Authorization failed, please contact customer service");
                },
                _this = this;
                YC_REQUEST_HANDLER.postQuery(url,params, successCallBack, failCallBack);
            }
        },
        loginSuccessHandler: function(response) {
            var data = response.data
            window.localStorage.setItem('userName', data.vo.user.nickname ? data.vo.user.nickname : data.vo.user.mobile)

            !!data.vo.org.id && window.localStorage.setItem('orgId', data.vo.org.id);
            !!data.vo.token && window.localStorage.setItem('token', data.vo.token);
            window.localStorage.setItem('tokenValidTime', data.vo.validTime ? data.vo.validTime : '');
            !!data.vo.user.id && window.localStorage.setItem('userId', data.vo.user.id);
            !!data.vo.user.mobile && window.localStorage.setItem('mobile', data.vo.user.mobile);
            window.localStorage.setItem('userState', data.vo.user.state);
            window.localStorage.setItem('level', data.vo.user.level);
            window.localStorage.setItem('orgStatus', data.vo.org.status || '');
            window.localStorage.setItem('orgAuditStatus', data.vo.org.auditStatus || '');
			window.localStorage.setItem('contractPartyId', data.vo.org.contractPartyId || '')
        },
        getUserInfo: function() {
            this.userInfo.name = window.localStorage.getItem("userName");
            this.userInfo.id = window.localStorage.getItem("userId");
            this.isLogined = this.userInfo.name !== null && this.userInfo.name !== "" && this.userInfo.id > 0;
        },
        accountLogin: function(newUrl) {
            debugger
            if (newUrl) {
                let suffix = '?oss_callback=' + encodeURIComponent(newUrl)
                window.open(process.env.VUE_APP_LOGIN_URL + suffix, '_self')
                return
            }
            let obj = UTILS.url2Obj(window.location.href)
            if (obj.token) {
                obj.token = undefined
            }
            let oss_callback = UTILS.obj2Url(obj)
            let suffix = oss_callback ? ('?oss_callback=' + encodeURIComponent(oss_callback)) : ''
			window.open(process.env.VUE_APP_LOGIN_URL + suffix, '_self')
			return
        },
        commonErrorHandler: function(msg) {
            this.showNotification(null, msg, null, 5000);
        },
        showNotification: function(title, message, closeCallBack, duration) {
            if (!title) {
                title = "Notification";
            }
            if (!message) {
                message = "Dear, the information is wrong, please check carefully!";
            }
            if (parseInt(duration) <= 0 || parseInt(duration) == NaN) {
                duration = 0;
            }
            this.$notify({
                title: title,
                message: message,
                duration: duration,
                type: "warning",
                onClose: closeCallBack
            });
        },
        showNotificationWithHTML: function(title, html, closeCallBack, duration) {
            if (!title) {
                title = "Notification";
            }
            if (!html) {
                html = "Dear, the information is wrong, please check carefully!";
            }
            if (parseInt(duration) <= 0 || parseInt(duration) == NaN) {
                duration = 0;
            }
            this.$notify({
                title: title,
                message: html,
                duration: duration,
                type: "warning",
                onClose: closeCallBack,
                dangerouslyUseHTMLString: true
            });
        },
        gotoTrailPage: function(customscode) {
            var reg = new RegExp("^[0-9]{3}-{0,1}[0-9]{8}$");
            if (customscode == "" || !reg.test(customscode)) {
                this.showNotification(null, 'Please enter the correct waybill number')
            } else {
                var subthree = customscode.substr(0, 3);
                if (UTILS.Valod_AWB_Prefix_Array.indexOf(subthree) == "-1") {
                    this.showNotification(null, 'This airline is not currently supported')
                    return false;
                }
                this.$router.push({
                    name: 'TrackPage',
                    query:{
                        customscode: customscode
                    }
                })
            }
        },

        createOrder: function(order) {
            // if (this.checkOrgAuth()) {
                this.$router.push({
                    name: 'OrderCreatePage',
                    query: order ? order : {
                        pieces: this.pieces,
                        grossWeight:  this.grossWeight,
                        volume: this.volume,
                        flightDate:  this.flightDate,
                        departure: this.departure,
                        destination: this.destination,
                        orderType: this.orderType,
                        supplierID: this.supplierID,
                        storeCode: this.storeCode,
                        airline: this.airlineCode,
                        productCode: this.productCode,
                        priceCode: this.priceCode,
                        declarationMethodOps: this.declarationMethodOps ? '0' : '1',
                        pickupType: this.pickupType ? '1' : '0'
                    }
                })
            // }
        },

        checkOrgAuth: function() {
            if (!this.login) {
                this.$confirm('You are not logged in, do you want to log in?', 'Notification', {
                    confirmButtonText: 'Sure',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    this.$message({
                        type: 'success',
                        message: 'About to log in!'
                    });
                    this.$bus.emit('toAccountLogin')
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: 'Sign in cancelled'
                    });
                });
                return false;
            }

            if (!this.org || !this.org.id) {
                this.$confirm('You have not submitted your company certification information. Do you want to go to the certification now?', 'Notification', {
                    confirmButtonText: 'Sure',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    this.$message({
                        type: 'success',
                        message: 'Jump authentication!'
                    });
                    window.open(process.env.VUE_APP_LOGIN_URL + '/manager/certification?token=' + this.token, '_self')
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: 'Certification cancelled'
                    });
                });
                return false;
            }

            if (this.org.auditStatus == 'OFF') {
                this.$confirm('The verification of the enterprise certification information you submitted failed. Do you want to contact customer service?', 'Notification', {
                    confirmButtonText: 'Sure',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    if (window.KF5SupportBoxAPI) {
                        window.KF5SupportBoxAPI.open();
                    }
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: 'Contact customer service has been cancelled'
                    });
                });
                return false;
            }

            return true
        }
    }
};
</script>
